// extracted by mini-css-extract-plugin
export var anchorLinkStyle = "AutoLinkHeader-module--anchorLinkStyle--68437";
export var linkAttentionFocus = "AutoLinkHeader-module--link-attention-focus--3ea8d";
export var parentAttentionFocus = "AutoLinkHeader-module--parent-attention-focus--4cf72";